@for (key of facetKeys; track key) {
  <app-multi-tree-select [label]="facetLabels[key]" [nodes]="facetNodes()[key]" (selectionChange)="updateFilters(key, $event)"></app-multi-tree-select>
}
